import { createAsyncThunk } from "@reduxjs/toolkit";
import { type Referral } from "../../../domain/entities/referral";
import { type CreateReferralParams } from "../../../domain/repos/referrals-repo";
import { type ReferralsDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const createReferral = createAsyncThunk<
  Referral,
  CreateReferralParams,
  { dispatch: ReferralsDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.CREATE_REFERRAL, async (params, { extra }) => {
  return await extra.referralsRepo.createReferral(params);
});
